import { NgModule }      from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { ScrollListener }   from '../scroll-listener';


@NgModule({
  imports:      [ ],
  declarations: [  ],
  providers: [ ScrollListener ],
  exports:      [ ],
})

export class ScrollerModule {
}


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/scroller/module/scroller.module.ts